import { applyScoreBranding } from '@acre/utils'

// When the flag is off this returns `flattenedMessages` by reference (not a copy), so the
// flag-off copy stays byte-identical to the pre-rebrand messages map.
export const getClientPortalMessages = (
  flattenedMessages: Record<string, string>,
  isScoreRebrandCP: boolean,
): Record<string, string> => (isScoreRebrandCP ? applyScoreBranding(flattenedMessages) : flattenedMessages)
